import Vue from 'vue';
import ShoppingListTable from './ShoppingListTable.vue';

$(document).ready(function() {
  const container = $('#shopping-list-container');
  if (container.length) {
    new Vue({
      el: '#shopping-list-container',
      template: '<ShoppingListTable />',
      components: {ShoppingListTable},
      data: container.data(),
    });
  }
});
